import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { dateFormatter } from 'common/helpers/date.helper';
import { MetricOverview } from 'common/components/MetricOverview';
import { EMetricType } from 'common/models/commonModel';
import { InfoTooltip } from 'common/components/InfoTooltip';
import { ITrackStoreSummary } from 'entities/TrackStore/TrackStore.models';

interface IComponentProps {
  summary: ITrackStoreSummary | null;
}

export const TrackStoreSummary: FC<IComponentProps> = ({ summary }) => {
  return (
    <div className="tsrt-summary">
      <div className="mb-5 flex flex-align-center flex-justify-between">
        <div className="ff-medium fs-xxs">{dateFormatter(summary?.lastUpdatedAt, 'MMM D, YYYY (dddd)')}</div>
        <InfoTooltip
          title={
            <div>
              <div className="mb-4 ff-medium fs-xxxs color-gray-1">{`See what's on track and what needs attention!`}</div>
              <div className="mb-4 ff-medium fs-xxxs color-gray-1">% of target achieved for:</div>
              <Row className="mb-4">
                <Col span={4} className="ff-regular fs-xxxs">
                  Sales
                </Col>
                <Col span={2} className="ff-regular fs-xxxs color-gray-1">
                  =
                </Col>
                <Col span={18} className="ff-regular fs-xxxs">
                  Total Sales
                </Col>
              </Row>
              <Row className="mb-4">
                <Col span={4} className="ff-regular fs-xxxs">
                  TC
                </Col>
                <Col span={2} className="ff-regular fs-xxxs color-gray-1">
                  =
                </Col>
                <Col span={18} className="ff-regular fs-xxxs">
                  Transaction Count
                </Col>
              </Row>
              <Row>
                <Col span={4} className="ff-regular fs-xxxs">
                  AC
                </Col>
                <Col span={2} className="ff-regular fs-xxxs color-gray-1">
                  =
                </Col>
                <Col span={18} className="ff-regular fs-xxxs">
                  Average Check
                </Col>
              </Row>
            </div>
          }
        />
      </div>

      <div>
        <div className="mb-4">
          <MetricOverview type={EMetricType.Sales} metric={summary?.sales} />
        </div>
        <div className="mb-4">
          <MetricOverview type={EMetricType.TransactionCount} metric={summary?.transactionCount} />
        </div>
        <div className="mb-4">
          <MetricOverview type={EMetricType.AverageCheck} metric={summary?.averageCheck} />
        </div>
      </div>
    </div>
  );
};
